// extracted by mini-css-extract-plugin
export default {"callToAction":"call_callToAction__ot8IQ","ctaButton":"call_ctaButton__Hk5Dn"};